<script>
  export let answer;
</script>
  
<div class="form-group row">
  <label for="resposta-da-questao" class="col-sm-2 col-form-label">Resposta: </label>
  <div class="col-sm-10">
    <textarea id="resposta-da-questao" name="resposta-da-questao" class='form-control' bind:value={answer.text}/>
  </div>
</div>